module.exports = __webpack_public_path__ + "img/rueckseite_neu_multi.da48c9da.svg";